import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { useNotificationContext } from 'core/states';
import { getFullUrl, goTo } from 'core/utils';
import { jobDetailsPath } from 'jobs/routes';
import { Variant } from 'theme/enums';

interface IProps {
  jobId: number;
}

export const SeeJobButton = ({ jobId }: IProps) => {
  const { t } = useTranslation();

  const { clearNotification } = useNotificationContext();

  const onClick = () => {
    clearNotification();

    goTo(getFullUrl(jobDetailsPath(jobId)), true);
  };

  return <Button text={t('buttonLabelSeeJob')} variant={Variant.SOFT} onClick={onClick} />;
};
